import { ReactNode } from 'react';
import LoadingSpinner from '../loadingSpinner/LoadingSpinner';

export interface WithLoadingSpinnerProps {
  isLoading: boolean;
  children: ReactNode;
}

const WithLoadingSpinner: React.FC<WithLoadingSpinnerProps> = ({
  isLoading,
  children,
}: WithLoadingSpinnerProps) => (
  <>
    {children}
    {isLoading && (
      <>
        <div className="fixed left-0 top-0 z-10 flex h-screen w-screen items-center justify-center bg-white opacity-30" />
        <div className="flex-column fixed top-1/2 left-1/2 z-20 flex items-center justify-center opacity-100">
          <button
            disabled
            type="button"
            className="focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 mr-2 inline-flex items-center rounded-lg bg-red px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-darker-red focus:ring-4"
          >
            <div className="mr-3">
              <LoadingSpinner 
                size="sm" 
                color="text-white" 
                className="py-0"
              />
            </div>
            Loading...
          </button>
        </div>
      </>
    )}
  </>
);

export default WithLoadingSpinner;
